import Axios from './axios';
import { LandingApi } from './landing';
import { TestApi } from './test';
export * from './test/types';

const url = `${window.location.protocol}//${window.location.hostname}`;

const getUrl = (): string => {
  if (url && url !== '') {
    return url;
  }
};

export const API = {
  TestApi: new TestApi(Axios, getUrl()),
  LandingApi: new LandingApi(Axios, getUrl()),
};
